import React from 'react'
import { ActionTypes } from '../../utils/Constants'
import Constants from '../../lib/aframeboxlookup/Constants';
import { Icon} from 'semantic-ui-react'

const { ActionStates } = Constants

const MessageIcon = ( { nextAction } ) => {

  let messageIcon;
  switch (nextAction) {
    default:
      messageIcon = null
      break;
    case ActionTypes.REQUEST_CART:
    case ActionTypes.SET_CART:
      messageIcon = <Icon name='cart' />
      break;

    case ActionTypes.SCAN_ARTICLE:
    case ActionStates.BOX_LOADED:  
      messageIcon = <Icon name='cube' />
      break;
    case ActionTypes.SEARCH_BOX:
    case ActionStates.LOAD_BOX:
      messageIcon = <Icon name="barcode" />
      break;
  }
  return messageIcon
}

export default MessageIcon